"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _useDebounce3 = require("use-debounce");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Close = _interopRequireDefault(require("../Icons/Close"));

var _Sync = _interopRequireDefault(require("../Icons/Sync"));

var _TouchableOpacity = _interopRequireDefault(require("../TouchableOpacity"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _useTranslation = _interopRequireDefault(require("./TranslationProvider/useTranslation"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var rotateAnimation = (0, _core.keyframes)(_templateObject());

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return {
    icon: {
      padding: spacing(0, 1),
      margin: spacing(-1)
    },
    loading: {
      animation: "".concat(rotateAnimation, " 1s ease infinite")
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

var Adornment = function Adornment(props) {
  var loading = props.loading,
      _props$debounceMs = props.debounceMs,
      debounceMs = _props$debounceMs === void 0 ? 500 : _props$debounceMs,
      other = (0, _objectWithoutProperties2["default"])(props, ["loading", "debounceMs"]);
  var t = (0, _useTranslation["default"])();
  var classes = useStyles();

  var _useDebounce = (0, _useDebounce3.useDebounce)(loading, debounceMs),
      _useDebounce2 = (0, _slicedToArray2["default"])(_useDebounce, 1),
      debouncedLoading = _useDebounce2[0];

  var showLoading = debouncedLoading && loading;
  return (0, _core.jsx)(_TouchableOpacity["default"], (0, _extends2["default"])({
    size: 6,
    type: "button",
    disabled: showLoading,
    "aria-label": showLoading ? t('loading') : t('delete_text')
  }, other), (0, _core.jsx)(_Icon["default"], {
    "data-testid": "Adornment",
    color: "icon",
    size: 6,
    as: showLoading ? _Sync["default"] : _Close["default"],
    css: /*#__PURE__*/(0, _css2["default"])([classes.icon, showLoading && classes.loading], ";label:Adornment;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
  }));
};

__signature__(Adornment, "useTranslation{t}\nuseStyles{classes}\nuseDebounce{[debouncedLoading]}", function () {
  return [_useTranslation["default"], useStyles, _useDebounce3.useDebounce];
});

var _default = Adornment;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(rotateAnimation, "rotateAnimation", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Adornment.tsx");
  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Adornment.tsx");
  reactHotLoader.register(Adornment, "Adornment", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Adornment.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Adornment.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();